import React, { useState, useEffect, useCallback } from 'react';
import leadsWebApi from '../services/leads-web';
import { buildFunnel } from '../utils/crm360Funnel';
import './Crm360.css';

const SERVICES = [
  { code: '', label: 'Tous services' },
  { code: 'VN', label: 'VN' }, { code: 'VO', label: 'VO' },
  { code: 'ATELIER', label: 'Atelier' }, { code: 'PIECES', label: 'Pièces' }, { code: 'AUTRE', label: 'Autre' },
];

const today = () => new Date().toISOString().slice(0, 10);
const yearStart = () => `${new Date().getFullYear()}-01-01`;

export default function LeadsFunnel({ user, concessionsList = [] }) {
  // Le backend ne force le cloisonnement que pour les opérateurs rattachés à une
  // concession ; tous les autres (super-admin inclus, même s'il a une concession) peuvent filtrer.
  const canFilterConcession = !(user?.role === 'operateur' && user?.concession_id);
  const [filters, setFilters] = useState({ date_debut: yearStart(), date_fin: today(), concession_id: '', service: '' });
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.date_debut) params.date_debut = filters.date_debut;
      if (filters.date_fin) params.date_fin = filters.date_fin;
      if (canFilterConcession && filters.concession_id) params.concession_id = filters.concession_id;
      if (filters.service) params.service = filters.service;
      const r = await leadsWebApi.getFunnel(params);
      setData(buildFunnel(r.data));
    } catch (e) {
      setData(null);
    } finally { setLoading(false); }
  }, [filters, canFilterConcession]);

  useEffect(() => { load(); }, [load]);

  const set = (k, v) => setFilters(f => ({ ...f, [k]: v }));

  return (
    <div>
      <div className="fnl-wip">🚧 Page en cours de construction, données pas encore viabilisées</div>

      <div className="page-toolbar">
        <input type="date" className="page-select" value={filters.date_debut} onChange={e => set('date_debut', e.target.value)} />
        <span style={{ color: 'var(--text-muted)' }}>→</span>
        <input type="date" className="page-select" value={filters.date_fin} onChange={e => set('date_fin', e.target.value)} />
        {canFilterConcession && concessionsList.length > 0 && (
          <select className={`page-select${filters.concession_id ? ' active-filter' : ''}`} value={filters.concession_id} onChange={e => set('concession_id', e.target.value)}>
            <option value="">Toutes concessions</option>
            {concessionsList.map(c => <option key={c.id} value={c.id}>{c.nom}</option>)}
          </select>
        )}
        <select className={`page-select${filters.service ? ' active-filter' : ''}`} value={filters.service} onChange={e => set('service', e.target.value)}>
          {SERVICES.map(s => <option key={s.code} value={s.code}>{s.label}</option>)}
        </select>
      </div>

      {loading || !data ? (
        <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>Chargement…</div>
      ) : (
        <>
          <div className="fnl-kpis">
            <div className="fnl-kpi"><div className="fnl-kpi-val">{data.stages[0].count}</div><div className="fnl-kpi-lbl">Leads reçus</div></div>
            <div className="fnl-kpi accent"><div className="fnl-kpi-val">{data.ventes}</div><div className="fnl-kpi-lbl">Ventes (Commande CRM360)</div></div>
            <div className="fnl-kpi"><div className="fnl-kpi-val">{data.tauxConversion}%</div><div className="fnl-kpi-lbl">Taux de conversion global</div></div>
            <div className="fnl-kpi"><div className="fnl-kpi-val">{data.perdus.total}</div><div className="fnl-kpi-lbl">Leads perdus (CRM360)</div></div>
          </div>

          <div className="table-container" style={{ padding: 18 }}>
            <div className="fnl">
              {data.stages.map((st, i) => {
                const max = data.stages[0].count || 1;
                const w = Math.max(2, Math.round((st.count / max) * 100));
                const cls = st.key === 'commande' || st.key === 'livraison' ? 'vente' : st.src;
                return (
                  <div className="fnl-row" key={st.key}>
                    <div className="fnl-label">{st.emoji} {st.label}</div>
                    <div className="fnl-bar-wrap">
                      <div className={`fnl-bar ${cls}`} style={{ width: `${w}%` }}>{st.count}</div>
                    </div>
                    <div className="fnl-pct">
                      <strong>{st.pctTotal}%</strong> du total
                      {i > 0 && <> · {st.pctPrev}% vs préc.</>}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="fnl-side">
              <div className="fnl-lost">
                <h4>❌ Perdus</h4>
                <div className="fnl-lost-row"><span>Abandonnés</span><strong>{data.perdus.abandonne}</strong></div>
                <div className="fnl-lost-row"><span>Refusés</span><strong>{data.perdus.refuse}</strong></div>
              </div>
              {data.aClasser.length > 0 && (
                <div className="fnl-aclasser">
                  <h4>⚠️ Statuts à classer</h4>
                  {data.aClasser.map(x => (
                    <div className="fnl-lost-row" key={x.statut}><span>{x.statut}</span><strong>{x.n}</strong></div>
                  ))}
                </div>
              )}
            </div>

            <p className="imp-hint" style={{ marginTop: 14 }}>
              Étapes 1-4 = parcours AUTODOM97 (reçu → contacté → RDV → transmis CRM360). Étapes 5-9 = statut CRM360 importé.
              Les leads « perdus » (abandonné / refusé) sont comptés à part car CRM360 ne fournit que le statut courant, pas l'étape d'abandon.
            </p>
          </div>
        </>
      )}
    </div>
  );
}
